






























import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { QuizInterface, MaterialInterface } from '@/interface/BaseInterface'
import BaseEditor from '@/components/base/editor/BaseEditor.vue'
import CreateMaterial from '../modules/CreateMaterial.vue'
import { namespace } from 'vuex-class'
import { SPopupBase } from '@/store/base'
import { filter } from 'lodash'

const tBase = namespace('base')

@Component({
  components: { BaseEditor, CreateMaterial }
})
export default class QuizFrom extends Vue {
  @Prop({ required: true, type: Object }) data!: QuizInterface
  @tBase.Action('setOpenPopup') setOpenPopup!: (data: SPopupBase) => void

  @Watch('data._id', { immediate: true }) watchId(new_: string) {
    if (new_ !== '') {
      if (this.$refs.editor) {
        //@ts-ignore
        this.$refs.editor.setData(this.data.description)
      }
    }
  }

  handleSubmit(data: any) {
    console.log(data)
    this.data.materials?.push(data)
  }

  handleRemoveMaterial(data: MaterialInterface) {
    this.data.materials = filter(this.data.materials, value => {
      return value.fileUrl !== data.fileUrl
    })
  }

  handleChange(value: string) {
    console.log(value)
    this.data.description = value
  }
}
